/* Vendored shadcn/ui `sonner` (110 §6 — this, not the deprecated toast/use-toast).
   The registry copy reads the theme from `next-themes`; we are not a Next app and our
   theme store is `stores/theme.tsx`, so it reads from there instead. That is the only
   change. */
import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useTheme } from '@/stores/theme';

export function Toaster(props: ToasterProps) {
  const { resolved } = useTheme();

  return (
    <Sonner
      theme={resolved}
      className="toaster group"
      position="bottom-right"
      toastOptions={{
        style: {
          background: 'var(--popover)',
          color: 'var(--popover-foreground)',
          border: '1px solid var(--border)',
          borderRadius: 'var(--radius-lg)',
          fontSize: 'var(--ui-font)',
        },
      }}
      {...props}
    />
  );
}

export { toast } from 'sonner';
